// Portão da sessão encerrada no meio do uso.
//
// Quando uma chamada recebe 401 e a sessão não renova sozinha, ela espera aqui até a pessoa
// entrar de novo pelo diálogo (ou outra aba entrar) ou sair. Todas as chamadas que caírem no
// portão enquanto ele está aberto esperam a mesma resposta e são repetidas com o token novo: o
// "Salvar" que a pessoa clicou conclui depois do login, com o que estava digitado.
//
// O diálogo (AuthContext) ouve o portão abrir e fechar; este módulo não conhece React.

type Ouvinte = (aberto: boolean) => void;

let espera: { promessa: Promise<string | null>; liberar: (token: string | null) => void } | null = null;
const ouvintes = new Set<Ouvinte>();

/** Abre o portão, ou entra na fila dele, e espera: o token novo, ou null se a pessoa saiu. */
export function aguardarReautenticacao(): Promise<string | null> {
  // Sem o AuthProvider montado não há diálogo para responder: a sessão fica dada como encerrada.
  if (ouvintes.size === 0) return Promise.resolve(null);
  if (!espera) {
    let liberar: (token: string | null) => void = () => {};
    const promessa = new Promise<string | null>((resolve) => {
      liberar = resolve;
    });
    espera = { promessa, liberar };
    ouvintes.forEach((ouvinte) => ouvinte(true));
  }
  return espera.promessa;
}

/** Fecha o portão: libera as chamadas com o token novo, ou com null quando a pessoa saiu. */
export function concluirReautenticacao(token: string | null): void {
  if (!espera) return;
  const { liberar } = espera;
  espera = null;
  ouvintes.forEach((ouvinte) => ouvinte(false));
  liberar(token);
}

/** O diálogo de sessão encerrada se inscreve aqui. Devolve a função que cancela a inscrição. */
export function ouvirReautenticacao(ouvinte: Ouvinte): () => void {
  ouvintes.add(ouvinte);
  return () => {
    ouvintes.delete(ouvinte);
  };
}
